import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { userDashboardAPI } from '../../services/api';
import UserLayout from './UserLayout'; // <--- IMPORT THE LAYOUT
import '../../styles/user/ChangePassword.css';

const ChangePasswordPage = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
        if (error) setError(null);
    };

    const validateForm = () => {
        if (!formData.currentPassword) {
            setError('Please enter your current password');
            return false;
        }
        if (!formData.newPassword) {
            setError('Please enter a new password');
            return false;
        }
        if (formData.newPassword.length < 6) {
            setError('New password must be at least 6 characters long');
            return false;
        }
        if (formData.newPassword !== formData.confirmPassword) {
            setError('New passwords do not match');
            return false;
        }
        if (formData.currentPassword === formData.newPassword) {
            setError('New password must be different from current password');
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!validateForm()) return;
        
        setLoading(true);
        setError(null);
        
        try {
            const response = await userDashboardAPI.changePassword({
                currentPassword: formData.currentPassword,
                newPassword: formData.newPassword
            });
            
            console.log('Password change response:', response);
            
            // Check if response is successful
            if (response?.success) {
                setSuccess(true);
                console.log('✅ Password changed successfully');
                
                // Clear form
                setFormData({
                    currentPassword: '',
                    newPassword: '',
                    confirmPassword: ''
                });
                
                // Show success and redirect after 2 seconds
                setTimeout(() => {
                    navigate('/user/dashboard');
                }, 2000);
            } else {
                setError(response?.message || 'Failed to change password');
            }
        } catch (err) {
            console.error('Change password error:', err);
            
            // Handle 401 error specifically (incorrect current password)
            if (err.response?.status === 401) {
                setError('Current password is incorrect. Please try again.');
            } else if (err.response?.data?.message) {
                setError(err.response.data.message);
            } else {
                setError('An error occurred. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    };

    const handleBack = () => {
        navigate('/user/dashboard');
    };

    return (
        <UserLayout activeTab="ChangePassword">
            
            {/* Main Content Area */}
            <div className="change-password-page" style={{ width: '100%' }}>
                <div className="change-password-container">
                    
                    {/* Header */}
                    <div className="password-header">
                        {/* Removed the "Back to Dashboard" button because it's handled by the global sidebar/nav */}
                        <h2>Change Password</h2>
                    </div>

                    {/* Success Message */}
                    {success && (
                        <div className="password-success">
                            <span className="success-icon">✅</span>
                            <p>Password changed successfully! Redirecting to dashboard...</p>
                        </div>
                    )}

                    {/* Error Message */}
                    {error && !success && (
                        <div className="password-error">
                            <span className="error-icon">⚠️</span>
                            <p>{error}</p>
                        </div>
                    )}

                    {/* Password Form */}
                    {!success && (
                        <form onSubmit={handleSubmit} className="password-form">
                            <div className="form-group">
                                <label htmlFor="currentPassword">Current Password</label>
                                <div className="input-wrapper">
                                    <span className="input-icon"></span>
                                    <input
                                        type="password"
                                        id="currentPassword"
                                        name="currentPassword"
                                        value={formData.currentPassword}
                                        onChange={handleChange}
                                        disabled={loading}
                                        autoFocus
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="newPassword">New Password</label>
                                <div className="input-wrapper">
                                    <span className="input-icon"></span>
                                    <input
                                        type="password"
                                        id="newPassword"
                                        name="newPassword"
                                        value={formData.newPassword}
                                        onChange={handleChange}
                                        disabled={loading}
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="confirmPassword">Confirm New Password</label>
                                <div className="input-wrapper">
                                    <span className="input-icon"></span>
                                    <input
                                        type="password"
                                        id="confirmPassword"
                                        name="confirmPassword"
                                        value={formData.confirmPassword}
                                        onChange={handleChange}
                                        disabled={loading}
                                    />
                                </div>
                            </div>

                            <div className="password-tips">
                                <span className="tips-icon">💡</span>
                                <span className="tips-text">Password must be at least 6 characters long</span>
                            </div>

                            <div className="password-actions">
                                <button 
                                    type="button" 
                                    className="cancel-btn"
                                    onClick={handleBack}
                                    disabled={loading}
                                >
                                    Cancel
                                </button>
                                <button 
                                    type="submit" 
                                    className="submit-btn"
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <span className="spinner-small"></span>
                                            Changing...
                                        </>
                                    ) : (
                                        'Change Password'
                                    )}
                                </button>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </UserLayout>
    );
};

export default ChangePasswordPage;